














































































import { AddSeasonModal, EditSeasonModal } from '@/components';
import { daysLeft } from '@/filters';
import { Season } from '@/models/geek-profile';
import { Actions, typedStore } from '@/store';
import { resetModel } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'SeasonsManagementView',
  components: {
    AddSeasonModal,
    EditSeasonModal,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      editedSeason: undefined as unknown as Season,
    };
  },
  created() {
    this.fetchSeasons();
  },
  computed: {
    seasons(): Season[] {
      return typedStore(this).state.seasons.seasons;
    },
  },
  filters: {
    daysLeft,
  },
  methods: {
    async fetchSeasons() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(Actions.seasons.fetchAllSeasons);
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    editSeason(season: Season) {
      this.editedSeason = season;
      this.$bvModal.show('edit-season-modal');
    },
  },
});
